import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { MessagingTab } from '@app/core';
import { Participation } from '@app/api';
import { useTranslation } from 'react-i18next';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    width: '100%',
    background: theme.colors.white,
    boxShadow: 'none',
    borderRadius: [theme.borderRadius.std, 0, 0, theme.borderRadius.std],
    paddingTop: theme.marginBase * 4,
    display: 'flex',
    overflow: 'hidden',
    flexDirection: 'column',
    height: '100%',
    [theme.media.mobile]: {
      borderRadius: 0,
      paddingTop: 0,
    },
  },
  headerContainer: {
    padding: [0, theme.marginBase * 3],
    marginBottom: theme.marginBase * 2,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.marginBase * 3,
    [theme.media.mobile]: {
      marginBottom: 0,
      paddingBottom: theme.marginBase * 2,
      boxShadow: theme.boxShadow.base,
    },
  },

  title: {
    ...theme.fonts.h4,
  },
}));

interface Values {
  participation: Participation;
}

export const ParticipantMessagingPane = ({ participation }: Values) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.container}>
      <div className={classes.headerContainer}>
        <h2 className={classes.title}>Messages</h2>
      </div>
      <MessagingTab
        participation={participation}
        participantView
        informationBox={t('messages.info')}
      />
    </div>
  );
};
